module.exports = __webpack_public_path__ + "static/media/carPred.fab06f9c.jpg";